import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Card,
  Grid,
  Button,
  DialogTitle,
  Popper,
  Dialog,
  DialogContent,
  DialogActions,
  Popover,
  makeStyles,
  Box
} from '@material-ui/core';
import { BiErrorCircle } from "react-icons/bi";
import { Edit, Check, Close } from '@material-ui/icons';
import EditIcon from '../../../Assets/EditIconEvaluation.svg';
import AcceptIcon from '../../../Assets/AcceptIcon.svg';
import XIcon from '../../../Assets/XIcon.svg';
import InfoIcon from '@material-ui/icons/Info';
import {
  getFacultyData,
  getSectionsViaExamId,
  updateEvaluation,
} from '../../../Utils/apiServices';
import KenSelect from '../../../global_components/KenSelect/index';
import KenButton from '../../../global_components/KenButton';
import KenLoader from '../../../Components/KenLoader';
import KenInputField from '../../../global_components/KenInputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles((theme) => ({
  NotAssignedButton: {
    height: '32px',
    backgroundColor: '#e8120045',
    fontSize: "12px",
    textTransform: 'inherit',
    borderRadius: "6px",
    '&:hover': {
      backgroundColor: '#e8120045',
    }
  },
  AssignButton: {
    height: '32px',
    backgroundColor: '#D0EED2',
    fontSize: "12px",
    textTransform: 'inherit',
    borderRadius: "6px",
    '&:hover': {
      backgroundColor: '#D0EED2',
    }
  },
  pendingButton: {
    height: '32px',
    backgroundColor: '#ffefb645',
    fontSize: "12px",
    textTransform: 'inherit',
    borderRadius: "6px",
    '&:hover': {
      backgroundColor: '#ffefb645',
    }
  },
  TableContainer:{
    background: '#ffffff',
    marginTop: '30px',
    color: theme.palette.KenColors.primary,
  },
  Popper: {
    color: 'red',
    marginLeft: '10px',
    width: '20px',
  },
  DialogContainer: {
    width: '600px',
    padding: '25px'
  },
  AddRow: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '24px'
  },
  cancelModal: {
    fontSize: '14px',
    textTransform: 'capitalize',
  },
  footerButtons:{
    marginTop:'16px',
  }

}))


function EvaluationSetup(props) {
  const { data, setData, setResetAPI, resetAPI, examData } = props;
  const [loader, setLoader] = useState();
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [saveDialogData, setSaveDialogData] = useState({ id:'', index:'' });
  const [inviligator, setInviligator] = useState({})
  const [facultyDetails, setFacultyDetails] = useState({});
  const [addRowButton, setAddRowButtom] = useState(true);
  const classes = useStyles();
  const handleOpenDialog = (id, index) => {
    setSaveDialogData({ id, index });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const [opens, setOpens] = React.useState(false);
  const handleClose = () => {
    setOpens(false);
  };

  useEffect(() => {
    getFacultyData().then((res) => {
      if (res?.records?.length > 0) {
        const data = res?.records?.map((el) => {
          return {
            label: el?.Name,
            value: el?.Id,
            ...el,
          };
        });
        setFacultyOptions(data);
      }
    });
  }, []);

  useEffect(() => {
    getSectionsViaExamId(examData?.data?.Id).then((res) => {
      if (res?.data?.length > 0) {
        const data = res?.data?.map((el) => {
          return {
            label: el?.section,
            value: el?.courseOfferingId,
            ...el,
          };
        });
        setSectionData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (Object.keys(inviligator).length !== 0 && Object.keys(facultyDetails).length !== 0) {
      setAddRowButtom(false)
    }
    else {
      setAddRowButtom(true)
    }
  }, [inviligator, facultyDetails])

  const [editCellId, setEditCellId] = useState(null);

  const handleEditClick = (id) => {
    // setEditCellId(id);
    if (data[id].status !== 'Accepted') {
      setEditCellId(id);
    }
  };
  const handleSaveClick = (id, index, payData) => {
    setSaveDialogData({ id, index });
    setOpenDialog(true);
  };
  const handleSaveModal = () => {
  handleSaveConfirmation()
  };



  // const handleSaveClick = (id, index) => {

  //   const dataCopy = [...data];
  //   let payload = {
  //     id: dataCopy[index].evaluatorId || '',
  //     evaluation: dataCopy[index].invigilatorId,
  //     exam: dataCopy[index].examId,
  //     status: dataCopy[index].status,
  //     reason: dataCopy[index].Reason || '',
  //     Course_Offering__c: data[index].courseOfferingId,
  //   };
  //   setLoader(true);

  //   updateEvaluation(payload)
  //     .then((res) => {
  //       if (res?.success) {
  //         setLoader(false);
  //         setResetAPI(!resetAPI);

  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoader(false);
  //     });
  //   setEditCellId(null);
  // };

  const handleCancelClick = (id) => {
    setEditCellId(null);
  };

  const getData = (value) => {
    const facultyOptionsCopy = [...facultyOptions];
    let selectedFaculty = facultyOptionsCopy.find((el) => el.Id === value);
    return {
      name: selectedFaculty.Name,
      age: selectedFaculty.Type_Of_Faculty__c,
      email: selectedFaculty.Email,
      invigilatorId: value,
    };
  };
  const getDataSection = (value) => {
    const sectionDataCopy = [...sectionData];
    let selectedSection = sectionDataCopy.find((el) => el.value === value);
    return {
      courseOfferingId: selectedSection?.value,
      section: selectedSection?.label,
    };
  };

  const handleAdd = () => {
    setOpens(true)
  };
  const handleAddRow = () => {
    const dataCopy = [...data];
    let id = dataCopy.length;
    setData([
      ...dataCopy,
      {
        id: id,
        evaluation: '',
        examId: examData?.data?.Id,
        status: '',
        reason: '',
        name: inviligator?.name,
        age: inviligator?.age,
        email: inviligator?.email,
        invigilatorId: '',
        facilityId: facultyDetails?.facilityId,
        room: facultyDetails?.room,
      },
    ]);
    let payload = {
      Course_Offering__c:facultyDetails.courseOfferingId,
      evaluation: inviligator.invigilatorId,
      exam:examData?.data?.Id,
    };
    handleSaveConfirmation(payload);
  }
  const handleSaveConfirmation = (payData) => {
    const dataCopy = [...data];
    const { id, index } = saveDialogData;
    let payload =  payData 
    ? payData :  {
      id: dataCopy[index].evaluatorId || '',
      evaluation: dataCopy[index].invigilatorId,
      exam: dataCopy[index].examId,
      status: dataCopy[index].status,
      reason: dataCopy[index].Reason || '',
      Course_Offering__c: data[index].courseOfferingId,
    };
    setLoader(true);
    updateEvaluation(payload)
      .then((res) => {
        if (res?.success) {
          setLoader(false);
          setResetAPI(!resetAPI);
        }
        handleCloseDialog();
        setOpens(false)
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        handleCloseDialog();
      });
    setEditCellId(null);
  };

  //popover for info button
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event, index) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const getStatus = (value) => {
    switch (value) {
      case 'Request': {
        return (
          <Button
            variant="contained"
            className={classes.pendingButton}>
            {value}
          </Button>
        );
      }

      case 'Accepted': {
        return (
          <Button
            variant="contained"
            className={classes.AssignButton}
            disableElevation
          >
            {value}
          </Button>
        );
      }
      case 'Rejected': {
        return (
          <Button
            variant="contained"
            className={classes.NotAssignedButton}
            disableElevation
          >
            Rejected
          </Button>
        )
      }

      default: {
        return (
          <Button
            variant="contained"
            className={classes.pendingButton}
            disableElevation
          >
            Pending
          </Button>
        );
      }
    }
  };

  return (
    <>
      {loader && <KenLoader />}
      <Grid container direction="column">
        <Grid >
            <TableContainer className={classes.TableContainer}>
              <Table  >
                <TableHead>
                  <TableRow >
                    <TableCell>Section Id</TableCell>
                    <TableCell>Evaluator</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Faculty Email</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  <>
                    {data?.length > 0 ? (
                      <>
                        {data?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ paddingLeft: '30px' }}>
                              {editCellId === index ? (
                                <KenSelect
                                  required={true}
                                  value={row.courseOfferingId}
                                  options={sectionData}
                                  onChange={(e) =>
                                    setData((prevData) =>
                                      prevData.map((prevRow) =>
                                        prevRow.id === index
                                          ? {
                                            ...prevRow,
                                            ...getDataSection(e.target.value),
                                          }
                                          : prevRow
                                      )
                                    )
                                  }
                                />
                              ) : (
                                row.section
                              )}
                            </TableCell>
                            <TableCell>
                              {editCellId === index ? (
                                <KenSelect
                                  required={true}
                                  value={row.invigilatorId}
                                  options={facultyOptions}
                                  onChange={(e) =>
                                    setData((prevData) =>
                                      prevData.map((prevRow) =>
                                        prevRow.id === index
                                          ? {
                                            ...prevRow,
                                            ...getData(e.target.value),
                                          }
                                          : prevRow
                                      )
                                    )
                                  }
                                />
                              ) : (
                                row.name
                              )}
                            </TableCell>
                            <TableCell>{row.age}</TableCell>
                            <TableCell>{row.email}</TableCell>
                            {/* <TableCell>{row.status}</TableCell> */}
                            <TableCell>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div>{getStatus(row.status)}</div>
                              <div>
                                {row.popUp == "Rejected" && <> <BiErrorCircle className={classes.Popper} aria-describedby={id} onClick={(event) => handleClick(event, index)} />
                                  <Popper id={id} open={open} anchorEl={anchorEl}>
                                    <div className={classes.paper}>{row.Reason}</div>
                                  </Popper> </>}
                              </div>
                            </div>
                          </TableCell>
                            {/* <TableCell>
                              {row.reason}
                            </TableCell> */}

                            <TableCell>
                              {editCellId === index ? (
                                <>
                                  <img src={AcceptIcon} style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      handleSaveClick(row?.id, index)
                                    } />

                                  <img src={XIcon} style={{ cursor: 'pointer' }} onClick={() => handleCancelClick(index)} />
                                </>
                              ) : (
                                <img src={EditIcon}
                                  onClick={() => handleEditClick(index)}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : (
                      <Typography
                        style={{
                          float: 'center',
                          alignItems: 'center',
                          textAlign: 'center',
                          marginTop: 20,
                        }}
                      >
                        No Data Found
                      </Typography>
                    )}
                  </>
                </TableBody>
              </Table>
            </TableContainer>
            <KenButton
              variant="outlined"
              style={{
                height: '36px',
                marginTop: '40px',
                float: 'left',
                marginBottom: '12px',
                background: "#08466F",
                color: "#ffff",
                textTransform: 'inherit',
                borderRadius: "6px",
                marginLeft: "30px"
              }}
              onClick={() => {
                handleAdd();
              }}
            >
              + Add More
            </KenButton>
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to save the changes?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSaveModal}
            color="primary"
            variant="contained"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={opens}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title">
        <Box className={classes.DialogContainer}>
          <Typography className={classes.AddRow}>Add Row</Typography>
          <Grid container spacing={2} >
            <Grid item xs={6}>
              <KenSelect
                required={true}
                // value={row.facilityId}
                label="section id"
                options={sectionData}
                placeholder={'Select Section ID'}
                onChange={(e) => {
                  const getFacility = getDataSection(e.target.value);
                  setFacultyDetails(getFacility)
                  console.log(getFacility, 'kisvinthh');
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <KenSelect
                label={'evaluator'}
                required={true}
                placeholder={'Select Invigilator'}
                // value={row.facilityId}
                options={facultyOptions}
                onChange={(e) => {
                  const uniqueInvigilator = getData(e.target.value);
                  setInviligator(uniqueInvigilator)
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <KenInputField
                label={'role'}
                required={true}
                value={inviligator?.age}
                readonly />
            </Grid>
            <Grid item xs={6}>
              <KenInputField
                label={'Faculty email'}
                required={true}
                value={inviligator?.email}
                readonly />
            </Grid><br />
            <Grid container justifyContent={'flex-end'} className={classes.footerButtons}>
              <Button
                variant="secondary"
                color="primary"
                onClick={() => {
                  setOpens(false)
                }}
                className={classes.cancelModal}
              >Cancel</Button>
              <Button
                variant="contained"
                color="primary"
                disabled={addRowButton}
                onClick={() => {
                  handleAddRow();
                }}

              >Assign</Button>
            </Grid>
          </Grid>
          <Box> 
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default EvaluationSetup;
